export default {"src":"/_next/static/media/shapes.6c24ece9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};